import { Box, Dialog, DialogContent, DialogTitle, IconButton } from "@material-ui/core"
import { X } from "react-feather"
import { HourReportForm } from "../HourReportForm/HourReportForm"
import { useHourReportForm } from "../../hooks/use-hour-report-form"
import { useHourReportFormOptions } from "../../hooks/use-form-options"
import type { HourReportingWorkflowSettings } from "../../hooks/use-hour-reporting-workflow-settings"
import { useTranslation } from "react-i18next"

type AddHourReportDialogProps = {
  date: Date
  selectedMembershipId: string | null
  workflowSettings?: HourReportingWorkflowSettings
  onClose: () => void
}

const AddHourReportDialog = ({ date, selectedMembershipId, workflowSettings, onClose }: AddHourReportDialogProps) => {
  const { t } = useTranslation("hour-report")
  const { formik, saveAsDraft, submitReport, isSubmitting } = useHourReportForm({
    initialDate: date.toISOString(),
    initialMembershipId: selectedMembershipId,
    onSubmitSuccess: onClose,
  })
  const { projectOptions, membershipOptions } = useHourReportFormOptions()

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <Box style={{ position: "absolute", right: 16, top: 8, zIndex: 1 }}>
        <IconButton edge="end" color="inherit" onClick={onClose}>
          <X size={20} />
        </IconButton>
      </Box>
      <DialogTitle>{t("dialogs.addTitle", { defaultValue: "Add hour report" })}</DialogTitle>
      <DialogContent>
        <HourReportForm
          formik={formik}
          saveAsDraft={saveAsDraft}
          submitReport={submitReport}
          projectOptions={projectOptions}
          membershipOptions={membershipOptions}
          isSubmitting={isSubmitting}
          showSaveAsDraft={false}
          workflowSettings={workflowSettings}
        />
      </DialogContent>
    </Dialog>
  )
}

export default AddHourReportDialog
